// src/services/quoteService.ts
import apiClient from './apiClient';
import { QuotesApiResponse } from '../types/quote';
import { toLegacyListResponse } from '../utils/normalizePaginatedResponse';
import type { Quote } from '../types/quote';

const QUOTES_PATH = 'quotes';

export const getQuotes = async (
  page = 1, 
  search = '',       // New parameter for search text (ID or Email)
  serviceType = '',  // New parameter for filtering (e.g., 'Import', 'Export')
  limit = 8
): Promise<QuotesApiResponse> => {
  try {
    // 1. Create the params object with defaults
    const params: Record<string, string | number> = { 
      page, 
      limit 
    };

    // 2. Add 'search' if user typed something
    if (search) {
      params.search = search;
    }

    // 3. Add 'serviceType' if user selected a filter
    if (serviceType) {
      params.serviceType = serviceType;
    }

    // 4. Make the API call with the params
    const response = await apiClient.get(QUOTES_PATH, { params });
    return toLegacyListResponse<Quote, 'quotes'>(response.data, 'quotes');
  } catch (error) {
    console.error('Failed to fetch quotes:', error);
    throw error;
  }
};